/**
 * Keeps the fixed Fitspire header below the announcement marquee,
 * sliding it up to the top of the viewport as the page scrolls.
 */
(() => {
  const marquee = document.querySelector('.announcement-marquee');
  const header = document.querySelector('store-header.fitspire-header');
  if (!marquee || !header) return;

  const updateOffset = () => {
    const offset = Math.max(0, marquee.offsetHeight - window.scrollY);
    header.style.transition = 'none';
    header.style.setProperty('--fitspire-top-offset-stuck', `${offset}px`);
  };

  updateOffset();
  window.addEventListener('scroll', updateOffset, { passive: true });
  window.addEventListener('resize', updateOffset);
})();
